import type { ModuleWithProviders } from '@angular/core';
import { NgModule, Optional } from '@angular/core';

import type { DevFlag } from '@recruitee/dev-flags-data';

import { AnalyticsGlobal } from './analytics-global';
import { AnalyticsRouteTracker } from './analytics-route.tracker';
import type { PageTrackParamsSanitizerFn, SegmentClientOptions } from './analytics.types';
import { Analytics, AnalyticsConfig } from './analytics.types';

@NgModule({
  imports: [],
  providers: [],
  exports: [],
})
export class RtAnalyticsModule {
  public static forRoot(opts: {
    segmentKey?: string;
    segmentOptions?: SegmentClientOptions;
    debug?: boolean;
    disable?: boolean;
    trackRouteChange: boolean;
    waitForIdentify?: boolean;
    pageTrackParamsSanitizer?: PageTrackParamsSanitizerFn;
    requiredFeatureFlag?: DevFlag;
  }): ModuleWithProviders<RtAnalyticsModule> {
    return {
      ngModule: RtAnalyticsModule,
      providers: [
        {
          provide: Analytics,
          useClass: AnalyticsGlobal,
        },
        {
          provide: AnalyticsConfig,
          useValue: new AnalyticsConfig(opts),
        },
        ...(opts.trackRouteChange
          ? [
              {
                provide: AnalyticsRouteTracker,
              },
            ]
          : []),
      ],
    };
  }

  constructor(
    // for eager initialization purposes
    @Optional() private routeTracker: AnalyticsRouteTracker,
  ) {}
}
